// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__07Ixu","container":"SectionFaq_container__WJJBm","faq__title":"SectionFaq_faq__title__GY59X","faq__list-container":"SectionFaq_faq__list-container__j__CF"};